import { Outlet } from "react-router-dom";

const Appeal = () => {
  return <Outlet />;
};
export default Appeal;

export { default as ComplaintList } from "./appeal-list";
export { default as ComplaintTopics } from "./complaint-topics";
